import { render, staticRenderFns } from "./SortableColumnText.vue?vue&type=template&id=5976c868&scoped=true&"
import script from "./SortableColumnText.vue?vue&type=script&lang=js&"
export * from "./SortableColumnText.vue?vue&type=script&lang=js&"
import style0 from "./SortableColumnText.vue?vue&type=style&index=0&id=5976c868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5976c868",
  null
  
)

export default component.exports